import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { preventDefault } from '@@client/lib/events';
import { classnames } from '@@client/lib/classes';

var LinkContent = function LinkContent(_ref) {
  var _ref$asIconLink = _ref.asIconLink,
      asIconLink = _ref$asIconLink === void 0 ? false : _ref$asIconLink;
  return asIconLink ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-2673322767" + " " + 'icon',
      children: /*#__PURE__*/_jsx(Image, {
        width: "20",
        height: "20",
        src: "/images/icons/icon-question.svg"
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2673322767",
      children: [".icon.jsx-2673322767{position:relative;width:16px;height:16px;top:2px;}"]
    })]
  }) : 'What is a core deposit?';
};

export default function CoreChargeMessage(_ref2) {
  var _ref2$asIconLink = _ref2.asIconLink,
      asIconLink = _ref2$asIconLink === void 0 ? false : _ref2$asIconLink,
      _ref2$linkKind = _ref2.linkKind,
      linkKind = _ref2$linkKind === void 0 ? 'link' : _ref2$linkKind,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? 'right' : _ref2$align;
  var moreInfoUrl = '/resources/faqs#core-deposit';

  var _useState = useState(false),
      isCoreMessageShown = _useState[0],
      setIsCoreMessageShown = _useState[1];

  var handleCoreMouseEnter = function handleCoreMouseEnter() {
    setIsCoreMessageShown(true);
  };

  var handleCoreMouseLeave = function handleCoreMouseLeave() {
    setIsCoreMessageShown(false);
  };

  var handleClick = preventDefault(function () {
    window.open(moreInfoUrl, '_blank');
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-2023370179" + " " + 'container',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-2023370179" + " " + 'the-link',
        children: linkKind === 'link' ? /*#__PURE__*/_jsx(Link, {
          href: moreInfoUrl,
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            onMouseEnter: handleCoreMouseEnter,
            onMouseLeave: handleCoreMouseLeave,
            className: "jsx-2023370179",
            children: /*#__PURE__*/_jsx(LinkContent, {
              asIconLink: asIconLink
            })
          })
        }) : /*#__PURE__*/_jsx("button", {
          onMouseEnter: handleCoreMouseEnter,
          onMouseLeave: handleCoreMouseLeave,
          onClick: handleClick,
          className: "jsx-2023370179" + " " + 'm--as-link',
          children: /*#__PURE__*/_jsx(LinkContent, {
            asIconLink: asIconLink
          })
        })
      }), isCoreMessageShown ? /*#__PURE__*/_jsx("div", {
        className: "jsx-2023370179" + " " + (classnames('message', 'align-' + align) || ""),
        children: "The \"core\" refers to your old part; the one you are replacing with a part from B&R. This deposit is refunded when your old part is returned."
      }) : null]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2023370179",
      children: [".container.jsx-2023370179{position:relative;width:100%;z-index:2;}", ".icon.jsx-2023370179{position:relative;width:16px;height:16px;top:2px;}", ".message.jsx-2023370179{position:absolute;font-style:normal;padding:5px 8px;font-size:0.875rem;border:1px solid #CCD0E0;background:#F0F1F6;border-radius:3px;top:30px;z-index:1;max-width:300px;min-width:200px;text-align:left;}", ".message.align-right.jsx-2023370179{left:10px;}", ".message.align-left.jsx-2023370179{right:10px;}"]
    })]
  });
}